import type { FollowUp, RealEstateCase } from "./types.ts";

export const LISTING_PREPARATION_NEXT_STEP = "Pripravené na zainzerovanie";

export const isLegacyPhotographyFollowUp = (followUp: FollowUp | undefined) => {
  const purpose = followUp?.purpose.toLocaleLowerCase("sk-SK") ?? "";
  return purpose.includes("foten") || purpose.includes("fotograf") || purpose.includes("upload fotograf");
};

export const isListingPreparationCase = (caseItem: RealEstateCase) =>
  !caseItem.followUp && caseItem.nextStep === LISTING_PREPARATION_NEXT_STEP;

export const removeLegacyPhotographyAction = (caseItem: RealEstateCase): RealEstateCase => {
  if (!isLegacyPhotographyFollowUp(caseItem.followUp)) return caseItem;
  return {
    ...caseItem,
    followUp: undefined,
    nextStep: LISTING_PREPARATION_NEXT_STEP
  };
};
